<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    <path d="M12,.09A12,12,0,0,0,0,12a11.74,11.74,0,0,0,2.14,6.77l-1.35,4a.5.5,0,0,0,.12.51.51.51,0,0,0,.51.13l4.2-1.33A12,12,0,0,0,24,12,12,12,0,0,0,12,.09Zm7.2,16.72a3.91,3.91,0,0,1-3.5,2.09,10.71,10.71,0,0,1-3.45-1A14,14,0,0,1,6.3,12.74c-1.91-2.53-2-4.9-.16-6.86A2.17,2.17,0,0,1,8,5.32a1.54,1.54,0,0,1,1.21.87l.38.92c.28.67.58,1.39.63,1.51a1.1,1.1,0,0,1,0,1,5.14,5.14,0,0,1-1,1.37,12.41,12.41,0,0,0,1.79,2.15,9.06,9.06,0,0,0,2.73,1.63c.28-.36.83-1,1-1.27a1,1,0,0,1,1.34-.36c.38.14,2.51,1.18,2.51,1.18a1.43,1.43,0,0,1,.68.49h0A2,2,0,0,1,19.2,16.81Z"/>
  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'messaging-whatsapp',
    },
    name: {
      type: String,
      required: false,
      default: 'MessagingWhatsapp',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>